import React, { Fragment } from 'react'


import Header from '../Navbar/Header';
import Footer from '../Footer';

const Layout = ({ children, title = "Homepage", description = "Homepage Desc", navbar = true, footer = true }) => {
    return (
        <Fragment>
            
           

            <div className='w-full overflow-hidden min-h-screen bg-white'>

                {
                    navbar ? <Header
                    className="fixed top-0 w-full z-10"
                    initialTextColor="black"
                    initialIconColor="black"
                    forceIconColor="black"
                    disableHoverEffect={true}
                  /> : ""
                }

                {children}

                {
                    footer ? <Footer /> : ""
                }
            </div>

            <script
                src="https://cdn.jsdelivr.net/npm/react/umd/react.production.min.js"
                crossOrigin="anonymous"
            ></script>

            <script
                src="https://cdn.jsdelivr.net/npm/react-dom/umd/react-dom.production.min.js"
                crossOrigin="anonymous"
            ></script>

            <script
                src="https://cdn.jsdelivr.net/npm/react-bootstrap@next/dist/react-bootstrap.min.js"
                crossOrigin="anonymous"
            ></script>
        </Fragment>
    )
}

export default Layout